 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		70: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		70: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"buybox~promotion-products-lazy~quick-view~write-a-review-form","5":"media-gallery-overlay-mobile~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","8":"buybox~promotion-products-lazy~quick-view","9":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~orange-lens","13":"bath-renovation~consumer-card-messaging","14":"buybox~quick-view","15":"media-gallery-overlay~media-gallery-overlay-mobile","16":"promotion-products-lazy~quick-view","19":"StoreLayout","20":"add-to-list-drawer","21":"aisle-bay","22":"augmented-reality","23":"bath-renovation","24":"breadcrumbs","25":"browse-and-search","26":"browse-and-search-mobile","27":"buybox","28":"calculator-pipcalculator","29":"collections","30":"collections-mobile","31":"common","32":"compare","33":"consumer-card-messaging","34":"customer-image-overlay","35":"drawer","36":"emt-generated-content","37":"emt-links","38":"fbr","39":"global-custom-configurator","40":"hammerjs","42":"home","43":"magic-apron","44":"measurement-guide","45":"measurement-guide-overlay-content","46":"media-gallery-filmstrip-mobile","47":"media-gallery-overlay","48":"media-gallery-overlay-mobile","49":"message-types","50":"orange-lens","51":"order-sample","52":"order-sample-drawer","53":"overlay","54":"paint-reorder","55":"paint-reorder-mobile","56":"pep","57":"pep-mobile","58":"product","59":"product-mobile","60":"product-overview","61":"promotion-products-lazy","62":"question","63":"questions-and-answers","64":"quick-view","65":"ratings-and-reviews","66":"ratings-and-reviews-desktop","67":"ratings-and-reviews-mobile","68":"results","69":"returns-messaging","71":"share-to-email-overlay","72":"share-to-pinterest-overlay","73":"size-guide-overlay","74":"specifications","75":"stylequiz","76":"super-sku","77":"vendor-collection-products","78":"vendor-collections","79":"vendor-collections-mobile","81":"video-player","82":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"c70de43def487ca7a1b1","1":"1e7a91ae5465878678c0","2":"aed31282d0f5f44fc868","3":"66ffc0584eedcd893d63","4":"9d77b6873ddb3c507c81","5":"536371a79e1a0278e004","6":"86d9bdc99b30e70be822","7":"2a35b66834d8b48b7c0a","8":"78f2ac6b5756371ecd8b","9":"20a56342f2e456ea7b48","10":"b751435e29b15a642187","11":"64e06b379d2bdb34045b","12":"a04bf7a2890ea3bf0578","13":"df3bf2c5b4bf834f4859","14":"1dcca3d454f0688b6152","15":"f60a0af876bd3908e26c","16":"3755835ab5ddef06a750","17":"548df39cf5d67b10fe00","18":"ee147947353e5d56bd81","19":"5190745ba5b335dd96ec","20":"eb37c1c653b4275deccb","21":"73305981cfb447fdc81e","22":"9d196cb13df3240a1299","23":"11a3a2889ae9d271fa3f","24":"131ac0ca78678597b757","25":"291051771ce980265313","26":"6a2d13a3ae806318638b","27":"67563cbb879210ccda05","28":"7694cf28b218725d32ea","29":"fa75e6e076b3a5c4069b","30":"d1569e97c81ddcadbe28","31":"8e5f7f322d088de683ea","32":"7efce6fd407574ac5b6a","33":"a88d4a2121fa45d389bd","34":"c5a4242ab5aeffbdc0cf","35":"369fe471de3dc6aa3510","36":"9424fc3bac4d03a46cf1","37":"249f01db17fe1703cb6b","38":"00ec502ad90d9510d8f4","39":"b15444d297d36042fc10","40":"ec8825588e5c82558c94","42":"ece00f50034cb45f5767","43":"5ff991306c8e73c089a7","44":"d734532eb4051830bc01","45":"44f7e0f46b40a069e24b","46":"afece174f40bc95fedc9","47":"5e73551145c2d5e61168","48":"f2679fd22f698f9ce82f","49":"f354e1192af8696917c6","50":"5bbbad9cae26a3d81fb4","51":"f721f7b602768cfe8cf4","52":"27f181786e4d8a249d4e","53":"27f993412d53b7e31cc3","54":"ec2485a0c47401716eb5","55":"7c03542bd103763dd6fe","56":"39d1ce5723f3af324bcb","57":"3b41bd7dda4e0433d36c","58":"c7bbddbf97290274e3e3","59":"15c37e2eb47f97d8f9b1","60":"ff14321972e1ce6e5349","61":"7b07b84ddc80155934af","62":"975819ccea9794299b0c","63":"e4989ec9f86a8a473618","64":"e6c978f670fa8fb8fd9f","65":"6b5263c6857d80fbc18e","66":"2578c734c60d2d0d1d2a","67":"bc294a317550da37aa17","68":"30011b4669903c9a41c4","69":"077b75b6b4ae0a276550","71":"7acca59feceb42588aca","72":"c8e09e53d44d01837ebf","73":"554c121b51362d0b456a","74":"b89a595088c8957e5a26","75":"ec7921baa7ea1defe8d6","76":"c8051ec8d779b4f1f728","77":"98915005bbd1b5d2b1dd","78":"f2f5a6240f129a73a4a6","79":"6272345cccf4dffa8e44","81":"f776e2d53c5d593ad5de","82":"3e89cb57f0ede0576ee0","83":"b6686085451b61f9c170"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"14":1,"15":1,"16":1,"21":1,"25":1,"26":1,"27":1,"29":1,"30":1,"32":1,"33":1,"34":1,"35":1,"36":1,"38":1,"39":1,"43":1,"46":1,"47":1,"48":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"63":1,"64":1,"65":1,"67":1,"73":1,"75":1,"76":1,"77":1,"78":1,"79":1,"82":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~0522c02d","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~paint-reorder~pain~1beba87a","4":"buybox~promotion-products-lazy~quick-view~write-a-review-form","5":"media-gallery-overlay-mobile~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile~write-a-review-form","8":"buybox~promotion-products-lazy~quick-view","9":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","10":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","11":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","12":"add-to-list-drawer~orange-lens","13":"bath-renovation~consumer-card-messaging","14":"buybox~quick-view","15":"media-gallery-overlay~media-gallery-overlay-mobile","16":"promotion-products-lazy~quick-view","19":"StoreLayout","20":"add-to-list-drawer","21":"aisle-bay","22":"augmented-reality","23":"bath-renovation","24":"breadcrumbs","25":"browse-and-search","26":"browse-and-search-mobile","27":"buybox","28":"calculator-pipcalculator","29":"collections","30":"collections-mobile","31":"common","32":"compare","33":"consumer-card-messaging","34":"customer-image-overlay","35":"drawer","36":"emt-generated-content","37":"emt-links","38":"fbr","39":"global-custom-configurator","40":"hammerjs","42":"home","43":"magic-apron","44":"measurement-guide","45":"measurement-guide-overlay-content","46":"media-gallery-filmstrip-mobile","47":"media-gallery-overlay","48":"media-gallery-overlay-mobile","49":"message-types","50":"orange-lens","51":"order-sample","52":"order-sample-drawer","53":"overlay","54":"paint-reorder","55":"paint-reorder-mobile","56":"pep","57":"pep-mobile","58":"product","59":"product-mobile","60":"product-overview","61":"promotion-products-lazy","62":"question","63":"questions-and-answers","64":"quick-view","65":"ratings-and-reviews","66":"ratings-and-reviews-desktop","67":"ratings-and-reviews-mobile","68":"results","69":"returns-messaging","71":"share-to-email-overlay","72":"share-to-pinterest-overlay","73":"size-guide-overlay","74":"specifications","75":"stylequiz","76":"super-sku","77":"vendor-collection-products","78":"vendor-collections","79":"vendor-collections-mobile","81":"video-player","82":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"46d0ac7da3db8adb1367","1":"66bba79b70e3924b990e","2":"31d6cfe0d16ae931b73c","3":"aaa0137a65d448ed5f64","4":"7647b1510da5618b37af","5":"83588448fb37280fe4ec","6":"89d9163eeb30e835d559","7":"1955189c596e6d9ade5e","8":"d6905e41bc7aa3f68e43","9":"0ef658ad0521bc70e648","10":"b31ab9f510c449fb1965","11":"7c2eed0c18c49e42c517","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"95a5994acce6e02a6b07","15":"19391484b2828e6b673c","16":"2a09750166a70e474555","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"d94b956aa532c1a50c65","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"96c3f664169e9b48c9f2","26":"838a3dcb3f28f3765d8d","27":"4dff0eff57ce1f73df40","28":"31d6cfe0d16ae931b73c","29":"b2ddf978d2543bdff784","30":"46d564885c9acf08eb20","31":"31d6cfe0d16ae931b73c","32":"ffe192ad5912a5ec682f","33":"c07ce9ab259c3f695942","34":"c466036523aec2558c34","35":"fc73174b407ad863c497","36":"b49004ddac99adec2224","37":"31d6cfe0d16ae931b73c","38":"88e24c7aafcf93ae6cc6","39":"1a5562a08d12f7682989","40":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"ceebf150d8a696023a14","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"e07956ac4ef9facbea2e","47":"80e7638adbdaec3de4f3","48":"94643b3e85240c6db752","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"b5080a0ec3bf23c04b62","54":"c6097d2cca00a8749b47","55":"ddf659a318102824d1e0","56":"eeeede101c3113a57d70","57":"cddafa022da934915b47","58":"4414a490db9eff8f33cd","59":"b5c79f5f1d887e65cf5a","60":"be155bb5d11dacdc4bb8","61":"c7e4a3cb02089bb4d052","62":"31d6cfe0d16ae931b73c","63":"d70c859b20e57c1599c5","64":"3fb67ef60d9f4cf19fb8","65":"adb0fe17b71f17fdebd9","66":"31d6cfe0d16ae931b73c","67":"2ade42f7647d0b013747","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"453dfc2640779a848cc6","74":"31d6cfe0d16ae931b73c","75":"6c6bdd949ddd0752832b","76":"922dbc8ed510a58afe20","77":"e518e335254638969e62","78":"fbae370640798a57513a","79":"05ba11d0a20efb76fea5","81":"31d6cfe0d16ae931b73c","82":"5512b06edf556d72360f","83":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
